import './styles/styles.css';
const Card = ({style, className, children}) => {
    return (
        <div className={`Card ${className}`} style={style} dir='rtl'>
            {children}
        </div>
    ) 
}

export default Card;